// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFiservCardVaultToken
 */
export interface IFiservCardVaultToken {
    /**
     * 
     * @type {string}
     * @memberof IFiservCardVaultToken
     */
    card_token_id?: string;
}

/**
 * Check if a given object implements the IFiservCardVaultToken interface.
 */
export function instanceOfIFiservCardVaultToken(value: object): value is IFiservCardVaultToken {
    return true;
}

export function IFiservCardVaultTokenFromJSON(json: any): IFiservCardVaultToken {
    return IFiservCardVaultTokenFromJSONTyped(json, false);
}

export function IFiservCardVaultTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFiservCardVaultToken {
    if (json == null) {
        return json;
    }
    return {
        
        'card_token_id': json['card_token_id'] == null ? undefined : json['card_token_id'],
    };
}

export function IFiservCardVaultTokenToJSON(json: any): IFiservCardVaultToken {
    return IFiservCardVaultTokenToJSONTyped(json, false);
}

export function IFiservCardVaultTokenToJSONTyped(value?: IFiservCardVaultToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'card_token_id': value['card_token_id'],
    };
}

